import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import { AppDataContext } from '~/contexts/AppDataContext';
import { getCSSFromTheme } from '~/utilities/getCSSFromTheme';
import { useMainCategoryPath } from '~/utilities/useMainCategoryPath';
import { usePropertyUrl } from '~/utilities/usePropertyUrl';

export default component$((): JSX.Element => {
  const article = useContext(ArticleContext);
  const { themeComponents } = useContext(AppDataContext);
  const homePath = usePropertyUrl();
  const mainCategoryPath = useMainCategoryPath();

  if (!article?.mainCategory) return <></>;

  const themeMap = {
    color: themeComponents.articleBlock.breadCrumbsTextColor.value,
    sizeSm: themeComponents.articleBlock.breadCrumbsFontSizeSmall.value,
    sizeMd: themeComponents.articleBlock.breadCrumbsFontSizeMedium.value,
    sizeLg: themeComponents.articleBlock.breadCrumbsFontSizeLarge.value,
  };

  const linkTheme = getCSSFromTheme(themeMap, 'hover:underline');
  const dividerTheme = getCSSFromTheme(themeMap, 'mx-2');

  return (
    <div class='my-8'>
      <a class={linkTheme} href={homePath}>
        Home
      </a>
      <span class={dividerTheme}>/</span>
      <a class={linkTheme} href={mainCategoryPath}>
        {article.mainCategory.displayName}
      </a>
    </div>
  );
});
